import React from 'react';
import './IEEEPage.css';
import PageHeader from '../about/PageHeader';
import Navbar from '../components/navbar';
import Footer from '../components/Footer';

const IEEEPage = () => {
  const Icons = {
    Global: () => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    Workshop: () => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        <path d="M16 7l2 2-7 7H9v-2l7-7z" />
      </svg>
    ),
    Conference: () => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
    Network: () => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    User: () => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    )
  };

  const features = [
    { title: "Global Recognition", icon: <Icons.Global />, desc: "Access to IEEE’s global publications, conferences and standards." },
    { title: "Technical Workshops", icon: <Icons.Workshop />, desc: "Hands-on seminars and workshops for skill enhancement." },
    { title: "International Conferences", icon: <Icons.Conference />, desc: "Participation in global IEEE symposiums and conferences." },
    { title: "Professional Networking", icon: <Icons.Network />, desc: "Build connections with industry leaders and researchers." }
  ];

  const faculty = [
    { name: "Dr. Vinita Gaikwad", role: "Branch Counselor" },
    { name: "Mr. Shirshendu Maitra", role: "Faculty In-Charge" },
    { name: "Ms. Rashmi Vipat", role: "Faculty In-Charge" }
  ];

  const students = [
    { id: 1, name: "Subeesh Sukumran", role: "Chairperson" },
    { id: 2, name: "Sonia Deora", role: "Co-Chairperson" },
    { id: 3, name: "Crina Joshi", role: "Secretary" },
    { id: 4, name: "Sumit Shedge", role: "Joint Secretary" },
    { id: 5, name: "Agalya Konar", role: "Treasurer" },
    { id: 6, name: "Shalaka Sane", role: "Joint Treasurer" },
    { id: 7, name: "Suraj Patel", role: "Member" },
    { id: 8, name: "Minal Sawant", role: "Member" },
    { id: 9, name: "Ruchika Manchekar", role: "Member" },
    { id: 10, name: "Shivam Tiwari", role: "Member" },
    { id: 11, name: "Alihasan Mulji", role: "Member" }
  ];

  const events = [
    {
      title: "Workshop on Amazon Alexa",
      date: "8th November 2019",
      venue: "TIMSCDR, Mumbai",
      time: "9 am – 5 pm",
      desc: `The IEEE Chapter at TIMSCDR organized a one-day workshop on “Amazon Alexa: Transition and Opportunities” by Hannan Satopay, Autodesk Tinkercad Advisor and Alexa Developer. 
      The workshop provided insights into the future of voice UI and Amazon Alexa skills. Participants explored and designed interactions between current and future technologies through structured demonstrations.`,
      images: [
        "/images/Life/IEEE/imgi_3_01-Workshop-on-Amazon-Alexa-by-Hannan-Satopay-2019-1.webp",
        "/images/Life/IEEE/imgi_4_02-Workshop-on-Amazon-Alexa-by-Hannan-Satopay-2019.webp",
        "/images/Life/IEEE/imgi_5_03-Workshop-on-Amazon-Alexa-by-Hannan-Satopay-2019.webp",
        "/images/Life/IEEE/imgi_6_04-Workshop-on-Amazon-Alexa-by-Hannan-Satopay-2019.webp"
      ]
    },
    {
      title: "IEEE STEP – Student Transition Elevation Partnership",
      date: "2nd March 2019",
      venue: "Thakur College of Engineering & Technology, Mumbai",
      time: "1:30 pm onwards",
      desc: `Four students from TIMSCDR participated in the IEEE Bombay Section Young Professionals Affinity Group STEP event. 
      The session guided students on transitioning from IEEE student membership to professional membership and planning section-level initiatives.`,
      images: [
        "/images/Life/IEEE/imgi_7_01-Transition-Elevation-Partnership-2019.webp",
        "/images/Life/IEEE/imgi_8_02-Transition-Elevation-Partnership-2019.webp"
      ]
    },
    {
      title: "Workshop on Actions on Google",
      date: "6th October 2018",
      venue: "TCET, Seminar Hall 3",
      time: "9 am – 5 pm",
      desc: `Conducted by Google Developer Student Club – Galgotias University Chapter (Delhi), this hands-on training focused on “Actions on Google” using Dialogflow and Google ML APIs.
      More than 100 students participated. 10 students from TIMSCDR successfully developed a Google App during the session.`,
      images: [
        "/images/Life/IEEE/imgi_9_01-Workshop-on-Actions-On-Google-2018.webp",
        "/images/Life/IEEE/imgi_10_02-Workshop-on-Actions-On-Google.webp",
        "/images/Life/IEEE/imgi_11_03-Workshop-on-Actions-On-Google-scaled.webp",
        "/images/Life/IEEE/imgi_12_04-Workshop-on-Actions-On-Google.webp"
      ]
    },
    {
      title: "IEEE Mumbai SBC & Admin Committee Meet",
      date: "6th October 2018",
      venue: "Vidyalankar School of IT, Wadala(E), Mumbai",
      time: "9 am – 4 pm",
      desc: `One faculty member and two students attended the Mumbai Division IEEE Student Branch Counselor and Admin Committee Meet-2018.
      It provided networking opportunities with IEEE Mumbai Chapter representatives and valuable knowledge-sharing sessions.`,
      images: [
        "/images/Life/IEEE/imgi_13_Mumbai-SBC-and-Admin-Committee-Meet-1.webp"
      ]
    }
  ];

  return (
    <>
      <Navbar />
      <div className="ieeeTims_wrapper">
        <PageHeader
          title="IEEE – TIMSCDR"
          crumbs={[
            { label: 'Home', href: '/' },
            { label: 'IEEE ', href: '#' }
          ]}
        />
        
        {/* ABOUT SECTION */}
        <div className="ieeeTims_section">
          <div className="ieeeTims_aboutGrid">
            <div className="ieeeTims_aboutLeft">
              <div className="ieeeTims_sectionTitlePrimary">About IEEE – TIMSCDR</div>
              <div className="ieeeTims_paragraph">
                IEEE is the world’s largest professional association dedicated to advancing technological innovation and excellence for the benefit of humanity. IEEE and its members inspire a global community through highly cited publications, conferences, technology standards and professional activities.
              </div>
              <div className="ieeeTims_paragraph">
                TIMSCDR launched its IEEE Student Chapter in 2018–19. The forum provides a platform for members to enhance technical skills and expand knowledge across domains. Members benefit from seminars, workshops, international conferences and access to IEEE’s monthly technical magazines.
              </div>
              <div className="ieeeTims_paragraph">
                Currently, IEEE–TIMSCDR has 12 student members and 2 professional members associated with it.
              </div>
            </div>

            <div className="ieeeTims_featureGrid">
              {features.map((feat, i) => (
                <div key={i} className="ieeeTims_featureCard">
                  <div className="ieeeTims_featureIconCircle">{feat.icon}</div>
                  <div className="ieeeTims_featureTitle">{feat.title}</div>
                  <div className="ieeeTims_featureDesc">{feat.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* WORKING COMMITTEE */}
        <div className="ieeeTims_section ieeeTims_bgLight">
          <div className="ieeeTims_sectionTitle">Working Committee</div>
          
          <div className="ieeeTims_facultyGrid">
            {faculty.map((f, i) => (
              <div key={i} className="ieeeTims_facultyCard">
                <div className="ieeeTims_facultyName">{f.name}</div>
                <div className="ieeeTims_facultyRole">{f.role}</div>
              </div>
            ))}
          </div>

          {/* STUDENT TABLE */}
          <div className="ieeeTims_studentTableWrapper">
            <table className="ieeeTims_studentTable">
              <thead>
                <tr>
                  <th>SR NO</th>
                  <th>Name</th>
                  <th>Designation</th>
                </tr>
              </thead>
              <tbody>
                {students.map(student => (
                  <tr key={student.id}>
                    <td>{student.id}</td>
                    <td>{student.name}</td>
                    <td>{student.role}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* EVENTS SECTION */}
        <div className="ieeeTims_section">
          <div className="ieeeTims_sectionTitle">IEEE Chapter Activities & Workshops</div>
          <div className="ieeeTims_eventGrid">
            {events.map((event, i) => (
              <div key={i} className="ieeeTims_eventCard">
                <div className="ieeeTims_eventTitle">{event.title}</div>
                <div className="ieeeTims_eventMeta">
                  <strong>{event.date}</strong> | {event.venue} | {event.time}
                </div>
                <div className="ieeeTims_eventDescription">
                  {event.desc}
                </div>

                {/* Image Gallery - Always Visible */}
                <div className="ieeeTims_gallery">
                  {event.images.map((img, index) => (
                    <div key={index} className="ieeeTims_imageWrapper">
                      <img src={img} alt="Event" />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default IEEEPage;